import { render, staticRenderFns } from "./profissionais_lista.vue?vue&type=template&id=17b0ed14&"
import script from "./profissionais_lista.vue?vue&type=script&lang=js&"
export * from "./profissionais_lista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports